export default __webpack_public_path__ + "static/media/logo_kadence_white.5a12a900.png";